// src/AuthContext.js - Updated
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, provider, signInWithPopup, signOut } from './firebase';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    // Add loading state
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUser(user);
            // Set loading to false once auth state is determined
            setLoading(false);
        });
        return unsubscribe;
    }, []);

    const login = async () => {
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    const logout = async () => {
        try {
            await signOut(auth);
            setUser(null);
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    // Add getToken method to retrieve ID token
    const getToken = async () => {
        if (!user) return null;
        try {
            const token = await user.getIdToken();
            return token;
        } catch (error) {
            console.error("Error getting token:", error);
            return null;
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading, getToken }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);